import React from 'react';

import { Button, Modal, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export default function DeleteModal({ contingent, chartId, organization, syncContingents, onClose }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [isDeleting, setIsDeleting] = React.useState(false);

    const onSubmit = React.useCallback(() => {
        setIsDeleting(true);
        contingent
            .delete({
                organizationId: organization.id,
                chartId: chartId,
                contingentId: contingent.uuid
            })
            .then(() => {
                toast.success(t('ticket.charts.contingents.list.deleteModal.toast-success'));
                onClose();
                syncContingents({ allow_cache: false, cache: false });
                setIsDeleting(false);
            })
            .catch(e => {
                console.error(e);
                toast.error(t('ticket.charts.contingents.list.deleteModal.toast-error'));
            })
            .finally(() => {
                setIsDeleting(false);
            });
    }, [contingent, chartId, organization, toast, onClose, syncContingents]);

    return (
        <Modal
            allowExternalClosing={false}
            open={Boolean(contingent)}
            onClose={onClose}
            submitButton={<Button primary label={t('ticket.common.action.delete')} onClick={onSubmit} isLoading={isDeleting} />}
            cancelButton={<Button onClick={onClose} label={t('ticket.common.action.cancel')} disabled={isDeleting} />}
            title={t('ticket.charts.contingents.list.deleteModal.title')}
        >
            <div>{t('ticket.charts.contingents.list.deleteModal.description')}</div>
        </Modal>
    );
}
